import { SVGProps, useId } from "react";

export default function ClipboardExportIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10 6L14 6C16 6 16 5 16 4C16 2 15 2 14 2L10 2C9 2 8 2 8 4C8 6 9 6 10 6Z"
        stroke={`url(#paint0_${id})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 22L9 22C4 22 3 20 3 16L3 10C3 5.44 4.67 4.2 8 4.02"
        stroke={`url(#paint1_${id})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4.02C19.33 4.2 21 5.43 21 10L21 15"
        stroke={`url(#paint2_${id})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M21 19L21 22L18 22"
          stroke={`url(#paint3_${id})`}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16L20.96 21.96"
          stroke={`url(#paint4_${id})`}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="12"
          y1="2"
          x2="12"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="8.5"
          y1="4.02"
          x2="8.5"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="18.5"
          y1="4.02"
          x2="18.5"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_${id}`}
          x1="19.5"
          y1="19"
          x2="19.5"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint4_${id}`}
          x1="17.98"
          y1="16"
          x2="17.98"
          y2="21.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}